import { ChangeDetectorRef, Directive, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ControlContainer } from '@angular/forms';
import { TableDataSource } from 'eurogard-data-source/table';
import { PaginatorLike } from 'eurogard-data-source/pagination';
import { MatSort } from '@angular/material/sort';
import { RxapFormArray } from 'eurogard-forms';
import { Subject } from 'rxjs';
import { ControlDataSource } from 'eurogard-form-system';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'table[mat-table][rxapFormTableDataSource]',
  standalone: true,
})
export class FormTableDataSourceDirective<Data extends Record<string, any> = any> implements OnInit {

  @Input()
  public paginator?: PaginatorLike;

  @Input()
  public sort?: MatSort;

  public control!: RxapFormArray<Data>;
  public refresh$ = new Subject<void>();
  private _dataSource?: TableDataSource<Data>;

  constructor(
    @Inject(MatTable)
    private readonly matTable: MatTable<any>,
    @Inject(ControlContainer)
    private readonly controlContainer: ControlContainer,
    @Inject(ChangeDetectorRef)
    private readonly cdr: ChangeDetectorRef,
    @Optional()
    @Inject(MatSort)
      sort: MatSort,
  ) {
    if (sort) {
      this.sort = sort;
    }
  }

  public ngOnInit() {

    const control = this.controlContainer.control;

    if (!(control instanceof RxapFormArray)) {
      throw new Error(`Control in not instance of RxapFormArray`);
    }

    this.control = control;

    let id = '[rxapFormTableDataSource]';

    if (control['controlId']) {
      // tslint:disable:no-string-literal
      id = (control as any)['controlId'];
    }

    const formDataSource = new ControlDataSource(control, {id});

    this.matTable.dataSource = this._dataSource = new TableDataSource(formDataSource, this.paginator);

  }

  public refresh() {
    this._dataSource?.refresh();
    this.cdr.detectChanges();
    this.refresh$.next();
  }

}


